import React from 'react'
import { connect } from 'redaction'
import { constants, links, mixpanel, compose } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'

import Link from 'components/ui/Link/Link'

import messages from './messages.js'
import s from './GetFreeButton.scss'

import maleImage from './images/invite_male.gif'
import femaleImage from './images/invite_female.gif'


const handleLinkClick = () => {
  mixpanel.track(constants.analyticsEvents.shareLinkClick, {
    placement: 'bird banner',
  })
}

const GetFreeButton = ({ gender, intl }) => {
  const image = gender === 'male' ? maleImage : femaleImage

  const label = intl.formatMessage(messages.label, { gender })

  return (
    <Link
      className={s.link}
      to={links.invite}
      data-testid={constants.testIds.common.getFreeBtn}
      onClick={handleLinkClick}
      aria-label={label}
    >
      <img className={s.image} alt="" src={image} />
    </Link>
  )
}


export default compose(
  connect({
    gender: 'models.me.gender',
  }),
  injectIntl,
)(GetFreeButton)
